import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  /**
   *
   * @param {
   *  "search": 검색어 필수
   * } param
   * @returns
   */
  getWholesalers(param) {
    return defaultClient.get(`/wholesalers?${qs.stringify(param)}`)
  },

  /**
   *
   * @param {
   *  "date": "2022-08-02"
   *  "file": file
   * }store
   * @returns
   */
  postWholesalerListFiles(wholesalerListFiles) {
    const formData = new FormData()
    for (const k in wholesalerListFiles) {
      formData.append(k, wholesalerListFiles[k])
    }

    return defaultClient.post('/wholesaler-files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  /**
   * 파일 목록
   * @param {
   *  "date": "2022-08-02"
   * } param
   * @returns
   */
  getWholesalerFiles(param) {
    return defaultClient.get(`/wholesaler-files?${qs.stringify(param)}`)
  },

  /**
   * 파일 삭제
   * @param {
   *  "uuid": 파일 uuid
   * } query
   * @returns
   */
  deleteWholesalerFiles({ uuid }) {
    return defaultClient.delete(`/wholesaler-files/${uuid}`)
  },
  /**
   * @deprecated v2 로 이관
   * @param {*} uuid
   * @returns
   */
  getWholesalerDetail(uuid) {
    return defaultClient.get(`/wholesalers/${uuid}`)
  },
  /**
   *
   * @param {{
   * "name": "블랙너츠",
   * "location": "역삼동 620 L층",
   * "phone": "02-540-0360"
   * } wholesalers
   * @returns
   */
  postWholesaler(wholesalers) {
    return defaultClient.post(`/wholesalers`, wholesalers)
  },
  /**
   *
   * @param {{
   * "wholesaler": "33333333",
   * "bank": "20",
   * "number": "100022222222",
   * "holderName":"김유빈",
   * } wholesalers
   * @returns
   */
  postWholesalerAccount(uuid, wholesalers) {
    return defaultClient.post(`/wholesalers/${uuid}/accounts`, wholesalers)
  },
}
